import axios from "axios";
import { API_HOST } from "../env";

export const AXIOS = axios.create({
  baseURL: API_HOST,
  withCredentials: true,
})